const TicketStatistic = ({ data }) => {
    return (
        <div className="acs__grid">
            <ul className="acs__list">
                <li className="acs__item">
                    <span>비즈니스 배너</span>
                    <span>
                        <b>{data?.businessBanner || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>그랜드 배너</span>
                    <span>
                        <b>{data?.grandBanner || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>그랜드 배너 고정옵션</span>
                    <span>
                        <b>{data?.grandBannerFixedOption || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>프리미엄 배너</span>
                    <span>
                        <b>{data?.premiumBanner || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>프리미엄 배너 고정옵션</span>
                    <span>
                        <b>{data?.premiumBannerFixedOption || 0}</b>개
                    </span>
                </li>
            </ul>
            <ul className="acs__list">
                <li className="acs__item">
                    <span>핫리쿠르트 배너</span>
                    <span>
                        <b>{data?.hitRecruitBanner || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>핫리쿠르트 배너 고정옵션</span>
                    <span>
                        <b>{data?.hitRecruitFixedOption || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>채용소식</span>
                    <span>
                        <b>{data?.recruitmentNews || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        채용소식 고정옵션 <span>(1주)</span>
                    </span>
                    <span>
                        <b>{data?.recruitmentFixedOption || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        하이라이트 강조<span>(1주)</span>
                    </span>
                    <span>
                        <b>{data?.highlightEmphasis1Week || 0}</b>개
                    </span>
                </li>
            </ul>
            <ul className="acs__list">
                <li className="acs__item">
                    <span>
                        하이라이트 강조<span>(2주)</span>
                    </span>
                    <span>
                        <b>{data?.highlightEmphasis2Week || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        컬러강조<span>(1주)</span>
                    </span>
                    <span>
                        <b>{data?.colorEmphasis1Week || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        컬러강조<span>(2주)</span>
                    </span>
                    <span>
                        <b>{data?.colorEmphasis2Week || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        아이콘 강조<span>(1주)</span>
                    </span>
                    <span>
                        <b>{data?.iconEmphasis1Week || 0}</b>개
                    </span>
                </li>
                <li className="acs__item">
                    <span>
                        아이콘 강조<span>(2주)</span>
                    </span>
                    <span>
                        <b>{data?.iconEmphasis2Week || 0}</b>개
                    </span>
                </li>
            </ul>
        </div>
    );
};
export default TicketStatistic;
